export default function FilterComponent({ children }) {
  return (
    <div style={{ textAlign: "center", padding: 15, margin: 0 }}>{children}</div>
  );
}
